import axios from "axios";
import { store } from "./store";
import { setIsLoading } from "./slices/global/LoaderSlice";

export const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "X-Custom-Header": "foobar" },
});

declare module "axios" {
  export interface AxiosRequestConfig {
    showLoader?: boolean;
  }
}

Api.interceptors.request.use(
  (config) => {
    console.log("config", config);
    if (config.showLoader) {
      store.dispatch(setIsLoading(true));
    }
    config.headers["ngrok-skip-browser-warning"] = "69420";
    return config;
  },
  (error) => {
    console.log("config err", error);
    store.dispatch(setIsLoading(false));
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  (response) => {
    console.log("response", response);
    if (response.config.showLoader) {
      store.dispatch(setIsLoading(false));
    }
    return response;
  },
  (error) => {
    console.log("mssg error", error);
    const apiMessage =
      error?.response?.data?.error || error?.response?.data?.errors?.[0];
    store.dispatch(setIsLoading(false));

    return Promise.reject({
      ...error,
      message: apiMessage,
      status: error.response?.status,
    });
  }
);
